export const TENANT_AI_WALLET_REFRESH_EVENT =
  "tenant-ai-wallet-updated";

function dispatchWalletEvent(detail) {
  if (typeof window === "undefined" ||
      typeof window.dispatchEvent !== "function") {
    return false;
  }

  window.dispatchEvent(new CustomEvent(
    TENANT_AI_WALLET_REFRESH_EVENT,
    { detail },
  ));
  return true;
}

/**
 * Ask mounted wallet views to refetch their server-authoritative summary.
 *
 * This event deliberately carries no balance or charge amount. Its only
 * purpose is to invalidate the browser's displayed wallet summary after a
 * server-side AI billing operation may have settled.
 */
export function requestTenantAiWalletRefresh() {
  return dispatchWalletEvent(null);
}

/** Invalidate pricing displays only after a saved configuration change. */
export function requestAiPricingRefresh(tenantId = null) {
  return dispatchWalletEvent({ pricingChanged: true, tenantId });
}

/**
 * Publish a tenant-safe summary that was embedded in an authenticated server
 * response. Consumers can render it immediately without issuing a duplicate
 * wallet callable. No client-derived cost or balance is accepted here.
 */
export function publishTenantAiWalletSummary(wallet) {
  if (!wallet || typeof wallet !== "object" || Array.isArray(wallet)) {
    // An embedded wallet is optional during a rolling backend deployment and
    // when the best-effort wallet read fails. Do not turn a high-frequency job
    // poll into a second high-frequency callable loop; the status bar retains
    // its normal interval and explicit post-operation invalidations.
    return false;
  }
  return dispatchWalletEvent({ wallet });
}
